import { ReactNode } from "react";
import { Navigate } from "react-router-dom";

export interface ProtectedRouteProps {
    /**
     * Tells if the route is allowed
     */
    isAllowed: boolean;
    /**
     * Path to redirect to if the route is not allowed
     */
    redirectPath?: string;
    /**
     * Fallback component to render if the route is not allowed
     */
    fallback?: ReactNode;
    /**
     * Children to render if the route is allowed
     */
    children: ReactNode;
}

const ProtectedRoute = ({ isAllowed, redirectPath, fallback, children }: ProtectedRouteProps): JSX.Element => {
    if (!isAllowed) {
        if (redirectPath) return <Navigate to={redirectPath} replace />;
        else if (fallback) return <>{fallback}</>; // skipcq: JS-0424
        else return <Navigate to="/" replace />;
    }

    return <>{children}</>; // skipcq: JS-0424
};

export default ProtectedRoute;
